import { Component } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';
import { CONSTANTS } from '../../../../Constants/Constants';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-export-proposal-required-field-dialog',
  imports: [
    CommonModule,
    TranslatePipe,
    MatButtonModule,
    MatTableModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,MatDialogModule],
  templateUrl: './export-proposal-required-field-dialog.component.html',
  styleUrl: './export-proposal-required-field-dialog.component.scss'
})
export class ExportProposalRequiredFieldDialogComponent {
  requiredFieldForm!: FormGroup<{
    name: FormControl<string>;
    email: FormControl<string>;
  }>;
   

  constructor(private readonly formBuilder: NonNullableFormBuilder,
    private readonly dialogRef: MatDialogRef<ExportProposalRequiredFieldDialogComponent>) {
    this.requiredFieldForm = this.formBuilder.group({
      name: [CONSTANTS.EMPTY_STRING, Validators.required],
      email: [CONSTANTS.EMPTY_STRING, [Validators.required, Validators.email]]
    });
  }


  onSubmit() {
    if (this.requiredFieldForm.valid) {
      this.dialogRef.close(this.requiredFieldForm.value);
    } else {
      this.requiredFieldForm.markAllAsTouched();
    }
  }
}
